
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import * as Pagos from '@lib/Ventas/Pagos'
import { isString } from 'util';
    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop()
        public value: { Descripcion: string, Id: string; } | string;

        @Watch( 'value', { immediate: true } )
        onIndex()
        {
            if ( typeof this.value === 'string')
            {
                this.Selected = this.items.find( x => x.Id === this.value );
            } else
            {
                this.Selected = this.value;
            }
            
        }

        constructor() {
            super();
        }

        public items: Array<{ Descripcion: string, Id: string; }> = [
            { Descripcion: 'Casa Jarse SAIC', Id:'casa-jarse' },
            { Descripcion: 'Jarse Industrial SA', Id:'jarse-industrial' }
        ]

        public selected: { Descripcion: string, Id: string; } | null = null;
        public get Selected(): { Descripcion: string, Id: string; } | null {
            return this.selected;
        }
        public set Selected( x: { Descripcion: string, Id: string; } | null ) {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }
    }
